export const ru = {
    contains: 'содержит',
    'day-placeholder': 'дд',
    equals: 'равен',
    'incorrect-date': 'Некорректная дата',
    'month-placeholder': 'мм',
    'not-contains': 'не содержит',
    'year-placeholder': 'гггг'
};
